export default __webpack_public_path__ + "static/media/send-message-in-private.fa473317.svg";